<template>
  <button :disabled="disabled" @click="onClick">
    <slot></slot>
  </button>
</template>

<script setup lang="ts">
import { ref } from 'vue'

defineProps<{
  disabled?: boolean
}>()

const emit = defineEmits<{
  // eslint-disable-next-line no-unused-vars
  (e: 'click', event: MouseEvent): void
}>()

const isWaiting = ref<boolean>(false)

function onClick(event: MouseEvent): void {
  if (isWaiting.value) {
    console.warn('Discarding debounced click')
    return
  }

  emit('click', event)
  isWaiting.value = true
  setTimeout(() => {
    isWaiting.value = false
  }, 500)
}
</script>
